import lookup from 'country-code-lookup';

export const country = {
  getCountryByIsoCode(isoCode: string | undefined) {
    return isoCode ? lookup.byIso(isoCode) : null;
  },
};
